module.exports = __webpack_public_path__ + "img/電気回路_1_7_5.060b39f8.jpeg";